// *********** LOGINADMIN() ***************************************
// *** Loginadmin.jsx ***********
// *** autor: W de Paula / MVinfo
// *** data: 16/12/24 | 10h25
// ***********************************************************


import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { encrypt } from '../../Services/cryptoUtils';
import { encryptPass } from '../../Services/cryptosenha.js';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from '../../../src/Services/apiaxios';

import AgendexLogo          from '../../Assets/agendex/iconLogoAgendex.png'
import AgendexAdminLogo from '../../Assets/agendex/logoagendexadmin.png'

import "./loginadmin.css";

function LoginAdmin() {
    var ano = new Date().getFullYear();

    const [emailadmin, setEmailAdmin] = useState('');
    const [senhaadmin, setSenhaAdmin] = useState('');
    const [mensagem, setMensagem] = useState('');
    const navigate = useNavigate(); // Hook para navegação
    const [loading, setLoading] = useState(false); // loading na tela

    useEffect(() => {
        const logoutMessage = localStorage.getItem('logoutMessage');
        if (logoutMessage) {
            setMensagem(logoutMessage);
            localStorage.removeItem('logoutMessage'); // Limpar após exibir
        }
    }, []);

    async function LoginUsuario() {
        try {
            if (!emailadmin || !senhaadmin) {
                setMensagem('Email ou Senha não pode ficar em branco.');
                setTimeout(() => {
                    setMensagem('');
                }, 5000);
                return;
            }
    
            setLoading(true);
    
            // console.log ('antes da api');
            const response = await apiaxios.post('/usuario/loginWeb', {
                email: emailadmin,
                senha: encryptPass(senhaadmin),
                tipoApp: 2
            });
            // console.log ('depois da api');
            // alert('depois do login');
    
            setLoading(false);
    
            const data = response.data;


    
            const userVars = {
                // tipoAgenda: Number(data.tipoAgenda), // 0 = global / 1= serviço individual
                // agenda_fechada: Number(data.agenda_fechada),
                // indempresa:  Number(data.indempresa), // cpf/cnpj length < 1 =0 / caso contrário=1 (ou seja, se o cadastro da empresa foi feito =1, se não = 0)
                // lock: Number(data.lock), // se o cadastro não está bloqueado por falta de pagamento = 0, caso contrário = 1
                // tipoAtendimento: Number(data.tipoatendimento), // carregar o Tipo de Atendimento (com (1) ou sem (0) colaboradores) 18/9/24w
                // login_colaborador: Number(data.login_colaborador || 0), // fazer separação entre prestador e seu funcionário 16/10/24w (1=colaborador / 0/undefined/null=prestador)
                // id_colaborador: Number(data.id_colaborador || 0), // carregar o id_colaborador se o login for específico, caso contrário = 0 17/10/24w
                // diasFimContrato: Number(data.diasFimContrato || 0), // carregar a quantidade de dias que faltam pra encerrar contrato(gratuito ou pago) ">=1 e <=5" 06/12/24w
                id_usuario: Number(data.id_usuario),
                ativa_conta: Number(data.ativa_conta), // usu_emailValidado
                validado:  Number(data.validado), // se cpf/cnpj foi validado pela equipe Agendex Adim = 1
                TAMANHO_PAGINA: 15
            }

            const encryptedUser = encrypt(userVars);
    
            localStorage.removeItem('logoutMessage');
            localStorage.setItem('tokenlg', encrypt("true"));
            localStorage.setItem('tokenaaw', encryptedUser); 
            localStorage.setItem('tokenasw', data.token);
            localStorage.setItem('userType', '2'); // 0= 'cliente' / 1= 'prestador' / 2= 'admin' // 23/9/24w

            // localStorage.setItem("buscaCidade", false);
    
            // console.log('data', data);
            // console.log('login userVar', userVars);
            // alert('depois do encryptedUser ser criado');
            // console.log('data.login_colaborador', data.login_colaborador);
            
            // alert('login prestador');

            navigate('/app/admin/home');
            // alert(userVars);
        } catch (error) {
            setLoading(false);
            if (error.message.includes('CORS policy')) {
                setMensagem('Erro de CORS. Verifique as configurações do servidor.');
            } else if (error.message === 'Failed to fetch') {
                setMensagem('Erro de conexão. Verifique sua conexão com a internet e tente novamente.');
            } else {
                setMensagem(error.message);
            }
            setTimeout(() => {
                setMensagem('');
            }, 7000);
        }
    }

    function ChangeMailAdmin(element) {
        setEmailAdmin(element.target.value.toLowerCase());
    }
    
    function ChangePasswordAdmin(element) {
        setSenhaAdmin(element.target.value);
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            LoginUsuario();
        }
    };

    return (
        <section id="logincliente">
            <div className="container login-container">
                <div className="row">
                    <div className="col-md-6 login-form-2">
                        <div className="login-logo">
                            <img src={AgendexLogo} alt=""/>
                        </div>
                        <img className="login-admin-img" src={AgendexAdminLogo} alt='Login Admin'/>

                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                        )}
                        <div className={`row ${loading ? 'd-none' : ''}`}></div>

                        <form>
                            <div className="form-group mb-3">
                                <input onChange={ChangeMailAdmin} type="email" className="form-control" id="emailadmin" name="emailadmin" placeholder="Digite seu Email cadastrado *" 
                                    autoComplete="username"  // Adiciona este atributo
                                    onKeyDown={handleKeyPress} 
                                />
                            </div>
                            <div className="form-group mb-3">
                                <input onChange={ChangePasswordAdmin} type="password" className="form-control" id="senhaadmin" name="senhaadmin" placeholder="Digite sua senha *"
                                    autoComplete="current-password"  // Adiciona este atributo
                                    onKeyDown={handleKeyPress} 
                                />
                            </div>
                            <div className="form-group mb-4">
                                <input onClick={LoginUsuario} type="button" className="btnSubmit" value="► Login" 
                                    onKeyDown={handleKeyPress} 
                                />
                                {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                            </div>
                            <div disabled className="form-group">
                                <Link to="/app/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
                            </div>
                        </form>
                    </div>
                </div>
                <p className="text-sm">(*) campos obrigatórios.</p>
                <div className="textoRodape">
                    <p>Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
                </div>
            </div>
        </section>
    );
}

export default LoginAdmin;